import { render, staticRenderFns } from "./filtrosBox.vue?vue&type=template&id=5eb5921a&scoped=true"
import script from "./filtrosBox.vue?vue&type=script&lang=js"
export * from "./filtrosBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb5921a",
  null
  
)

export default component.exports